<script setup>

import {computed, useSlots} from "vue";

const props = defineProps({
    styleType: {
        type: String,
        required: false,
        default: 'default',
        options: ['default', 'danger'],
    }
})

const styleTypeClasses = computed(() => {
    switch (props.styleType) {
        case 'transparent':
        return 'border-gray-200 bg-transparent'
        case 'danger':
            return 'border-red-100 bg-red-50 text-red-700'
        case 'info':
            return 'border-blue-200 bg-blue-50'
        case 'default':
        default:
            return 'border-gray-200 bg-gray-50 text-gray-700'
    }
})

const slots = useSlots()

const hasHeaderSlot = computed(() => !!slots.header || !!slots.title || !!slots.topRight)

</script>

<template>
    <div
        class="p-3 border rounded-lg text-xs"
        :class="styleTypeClasses"
    >
        <div
            v-if="hasHeaderSlot"
            class="flex justify-between pb-2"
        >
            <span>
                <slot name="header" />
                <slot name="title" />
            </span>
            <span>
                <slot name="topRight"></slot>
            </span>
        </div>

        <slot />
    </div>
</template>
